import cx from "classnames";
import { type InputHTMLAttributes, forwardRef, useLayoutEffect, useRef, useState } from "react";

interface EditInPlaceInputProps extends InputHTMLAttributes<HTMLInputElement> {
	textSize?: "sm" | "md";
	autoSize?: boolean;
}

export const EditInPlaceInput = forwardRef<HTMLInputElement, EditInPlaceInputProps>(
	({ textSize = "sm", autoSize = false, className, value, placeholder, ...rest }, ref) => {
		const measureRef = useRef<HTMLSpanElement>(null);
		const [width, setWidth] = useState<number | undefined>();

		useLayoutEffect(() => {
			if (autoSize && measureRef.current) {
				setWidth(measureRef.current.scrollWidth);
			}
		}, [autoSize, value, placeholder]);

		const displayValue = value || placeholder || "";

		const sharedClasses = cx(`input-text--${textSize}`, `text-${textSize}`, className);

		return (
			<>
				{autoSize && (
					<span
						ref={measureRef}
						className={cx(
							sharedClasses,
							"invisible fixed whitespace-pre pointer-events-none"
						)}
						aria-hidden
					>
						{displayValue}
					</span>
				)}
				<input
					{...rest}
					ref={ref}
					value={value}
					placeholder={placeholder}
					style={autoSize && width != null ? { width: `${width}px` } : undefined}
					className={cx(
						sharedClasses,
						"block",
						!autoSize && "w-full",
						"text-primary",
						"bg-transparent",
						"focus:ring-0",
						"focus:outline-none"
					)}
				/>
			</>
		);
	}
);

EditInPlaceInput.displayName = "EditInPlaceInput";
